import { LEAD_TYPE } from '@/features/lead-form/constants/leadType';
import type { LeadType } from '@/features/lead-form/constants/leadType';
import type { LeadFormName } from '@/features/lead-form/constants/formName';
import type { ProductType } from '@/features/lead-form/types/leadData';

import {
  PDF_DOWNLOAD_CONFIG,
  PDF_DOWNLOAD_FILES,
  type PdfDownloadCategory,
  type PdfDownloadName,
  type PdfDownloadProduct,
} from './data';

// ─────────────────────────────────────────────────────────
// 정적 상품 소개서 조회
// ─────────────────────────────────────────────────────────

export const toPdfFileName = (name: string) => `${name} 소개서.pdf`;

export function resolveStaticPdfDownload(pdf: PdfDownloadName) {
  if (!Object.hasOwn(PDF_DOWNLOAD_FILES, pdf)) return undefined;

  const name = pdf as PdfDownloadProduct;
  return {
    category: 'product' as const,
    name,
    file: { fileUrl: PDF_DOWNLOAD_FILES[name], fileName: toPdfFileName(name) },
  };
}

// ─────────────────────────────────────────────────────────
// buildFormProps — CONFIG.form 값을 그대로 사용, 상품만 예외
// ─────────────────────────────────────────────────────────

export type FormPropsContext = {
  category: PdfDownloadCategory;
  productName?: PdfDownloadProduct;
  maruBranchId?: number;
  downloadPurpose: string[];
};

export type PdfDownloadFormProps = {
  formName: LeadFormName;
  leadType: LeadType[];
  productType: ProductType[];
  extraData: Record<string, unknown>;
};

/**
 * 새 카테고리는 PDF_DOWNLOAD_CONFIG.form에 formName/leadType/productType만 정의
 */
export function buildFormProps(ctx: FormPropsContext): PdfDownloadFormProps {
  const { category, productName, maruBranchId, downloadPurpose } = ctx;
  const extraData = {
    downloadPurpose,
    ...(maruBranchId != null
      ? { interestedBranchIds: [String(maruBranchId)] }
      : {}),
  };

  if (category === 'product') {
    if (!productName) throw new Error('상품 소개서 이름이 필요합니다.');

    return {
      formName: PDF_DOWNLOAD_CONFIG.product.form.formName,
      leadType: [LEAD_TYPE.SHARED_OFFICE],
      productType: [productName],
      extraData,
    };
  }

  const { formName, leadType, productType } = PDF_DOWNLOAD_CONFIG[category].form;
  return {
    formName,
    leadType: [leadType],
    productType: [productType],
    extraData,
  };
}
